import React from "react";
import { Box, Dialog, Typography } from "@mui/material";
import PracticeActions from "./practice/PracticeActions";
import PracticeCardStage from "./practice/PracticeCardStage";
import PracticeCompleteCard from "./practice/PracticeCompleteCard";
import PracticeProgressHeader from "./practice/PracticeProgressHeader";

function PracticeModeDialog({
  open,
  cards,
  practiceCards,
  selectedDeck,
  practiceCard,
  practicePhase,
  practicePhaseIndex,
  practiceMeta,
  practiceIndex,
  practiceProgress,
  practiceStats,
  practiceFlipped,
  practiceAnswer,
  practiceResult,
  isPracticeDone,
  isReviewingCard,
  onClose,
  onResetPractice,
  onAdvancePractice,
  onPracticeRecall,
  onCheckPracticeAnswer,
  onGetAdvanceLabel,
  onSetPracticeFlipped,
  onSetPracticeAnswer,
  onSetPracticeResult,
}) {
  return (
    <Dialog
      fullScreen
      open={open && Boolean(selectedDeck)}
      onClose={onClose}
      PaperProps={{
        sx: {
          background: "linear-gradient(180deg, #fbfdff 0%, #eef8ff 100%)",
        },
      }}
    >
      <Box
        sx={{
          minHeight: "100dvh",
          p: { xs: 2, md: 3 },
          display: "grid",
          gridTemplateRows: "auto minmax(0, 1fr) auto",
          gap: { xs: 2, md: 1.5 },
          bgcolor: "var(--toeic-paper)",
          overflow: "hidden",
        }}
      >
        <PracticeProgressHeader
          cards={practiceCards}
          selectedDeck={selectedDeck}
          practicePhase={practicePhase}
          practicePhaseIndex={practicePhaseIndex}
          practiceMeta={practiceMeta}
          practiceIndex={practiceIndex}
          practiceProgress={practiceProgress}
          isPracticeDone={isPracticeDone}
          onClose={onClose}
        />

        <Box sx={{ alignSelf: { xs: "center", md: "start" }, width: "100%", maxWidth: 980, mx: "auto", minHeight: 0 }}>
          {isPracticeDone ? (
            <PracticeCompleteCard cards={cards} practiceStats={practiceStats} />
          ) : practiceCard ? (
            <PracticeCardStage
              practiceCard={practiceCard}
              practicePhase={practicePhase}
              practiceMeta={practiceMeta}
              practiceFlipped={practiceFlipped}
              practiceAnswer={practiceAnswer}
              practiceResult={practiceResult}
              onSetPracticeFlipped={onSetPracticeFlipped}
              onSetPracticeAnswer={onSetPracticeAnswer}
              onSetPracticeResult={onSetPracticeResult}
              onCheckPracticeAnswer={onCheckPracticeAnswer}
              onAdvancePractice={onAdvancePractice}
            />
          ) : (
            <Box sx={{ p: 4, borderRadius: "18px", bgcolor: "#fffefd", textAlign: "center", border: "1px solid #d7eaf5" }}>
              <Typography sx={{ color: "var(--toeic-ink-soft)" }}>
                This deck has no cards yet.
              </Typography>
            </Box>
          )}
        </Box>

        <PracticeActions
          isPracticeDone={isPracticeDone}
          practicePhase={practicePhase}
          practiceFlipped={practiceFlipped}
          practiceCard={practiceCard}
          practiceAnswer={practiceAnswer}
          practiceResult={practiceResult}
          practiceMeta={practiceMeta}
          isReviewingCard={isReviewingCard}
          onClose={onClose}
          onResetPractice={onResetPractice}
          onAdvancePractice={onAdvancePractice}
          onPracticeRecall={onPracticeRecall}
          onCheckPracticeAnswer={onCheckPracticeAnswer}
          onGetAdvanceLabel={onGetAdvanceLabel}
          onSetPracticeFlipped={onSetPracticeFlipped}
        />
      </Box>
    </Dialog>
  );
}

export default PracticeModeDialog;
